import React, { useEffect, useState } from "react";
import { alertify, handleApiExceptions } from "../../app_methods";
import { Button, Form, Icon, Select, Spin } from "antd";
import { Text1 } from "../../styles";
import { CreateSplitAccountModal } from "../Settings/InstaCollect/splitAccountModal";
import { SplitAccountModel } from "../../models/split_account";
import { SplitAccDrawer } from "./styles";
import { SplitsConfigForm } from "../Common/Forms";

const SplitAccountsDrawer = (props) => {
    const { width, visible, onClose, merchantId, split_settlement_type, virtualAccount, cva_id, can_edit } = props;
    const [isRetrieving, setIsRetrieving] = useState(false);
    const [splitAccountData, setSplitAccountData] = useState([]);
    const [selectedSplitAccount, setSelectedSplitAccount] = useState(null);
    const [showModal, setShowModal] = useState(false);
    useEffect(() => {
        if (visible && merchantId) {
            fetchSplitAccounts();
        }
    }, [visible]);

    const fetchSplitAccounts = async (_pagination) => {
        setSplitAccountData([])
        setIsRetrieving(true);
        const response = await SplitAccountModel.list({
            merchant_id: merchantId,
            custom_virtual_account_id: split_settlement_type == "CVA" ? cva_id : null,
            ...{ pageSize: _pagination?.pageSize, current: _pagination?.current },
        });
        if (!response.success) {
            handleApiExceptions(response);
            setIsRetrieving(false);
            return;
        }
        setIsRetrieving(false);
        setSplitAccountData(response?.data?.split_accounts || []);
    };

    const saveAccount = async (values) => {
        setIsRetrieving(true);
        const account = new SplitAccountModel(values);
        const response = await account.save();
        if (!response.success) {
            setIsRetrieving(false);
            handleApiExceptions(response);
            return;
        }
        setShowModal(false);
        alertify("Success", `Split Account ${values.id ? "updated" : "created"} successfully.`, "success", {
            cancelText: "Close",
        });
        setIsRetrieving(false);
        fetchSplitAccounts();
    };

    const handleSplitUpdate = (splitAccount) => {
        setSelectedSplitAccount(splitAccount);
        setShowModal(!showModal);
    };

    //Ascending order Split Accounts Data
    let sortedSplitAccountsData = splitAccountData?.sort((a, b) => {
        const nameA = a.approval_status.toUpperCase(); // ignore upper and lowercase
        const nameB = b.approval_status.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        // names must be equal
        return 0;
    });

    return (
        <SplitAccDrawer
            className="split-accounts-drawer"
            visible={visible}
            title={<Text1>Split Accounts</Text1>}
            onClose={onClose}
            width={width}
            hideBackArrow={true}
            hideFooter={true}
            destroyOnClose
        >
            <div className="h-100">
                <div className="w-100">
                    <Spin spinning={isRetrieving}>
                        {!isRetrieving ? <SplitsConfigForm
                            fetchSplitAccounts={fetchSplitAccounts}
                            onClose={onClose}
                            setSelectedSplitAccount={setSelectedSplitAccount}
                            isRetrieving={isRetrieving}
                            setShowModal={setShowModal}
                            handleSplitUpdate={handleSplitUpdate}
                            splitAccounts={sortedSplitAccountsData}
                            split_settlement_type={split_settlement_type}
                            virtualAccount={virtualAccount}
                            can_edit={can_edit}
                        /> : null}
                    </Spin>
                </div>
            </div>
            <CreateSplitAccountModal
                visible={showModal}
                onCancel={() => setShowModal(false)}
                merchantID={merchantId}
                selectedSplitAccount={selectedSplitAccount}
                saveAccount={saveAccount}
                loading={isRetrieving}
            />
        </SplitAccDrawer>
    );
};

export { SplitAccountsDrawer };
